module.exports = __webpack_public_path__ + "static/media/7.3f72a248.JPG";